module.exports = __webpack_public_path__ + "img/geographicalDistributions.681adb2d.svg";